// Module
var code = `<div class="resources-container fade-in container"><h2>Resources Stub</h2></div>`;
// Exports
export default code;